import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2kekbkmu5g: FaireBrandEntity = {
  token: "b_2kekbkmu5g",
  type: "brand",
  name: "naomi",
  avatarUrl:
    "https://cdn.faire.com/fastly/5943d79db402176b535f3215b739637aa2eed5ffc7bc749cbeee0dd931da1e89.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6730ffb73cac791d17a3fbe0581d847949af852038ad59eda1e4b175866805bb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5943d79db402176b535f3215b739637aa2eed5ffc7bc749cbeee0dd931da1e89.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6730ffb73cac791d17a3fbe0581d847949af852038ad59eda1e4b175866805bb.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 144,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "For hardworking hands. We cooked for Michelin star restaurants before launching naomi. It's for people who believe that hands are the most important tool in the kitchen.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:55.515Z",
    importedBy: "entity-db-cli",
  },
};
